
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlA as ObiOwnShipControlAElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-a.js';
 
 
 

 
 export const ObiOwnShipControlA = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-a',
   elementClass: ObiOwnShipControlAElement,
   events: {
     
   }
  });
 
 